export default {
  getUserList: "BackEnd/getUserList",
  getUserListDeatils: "BackEnd/getUserListDeatils",
  updateAccountData: "BackEnd/updateAccountData",
};
